export default __webpack_public_path__ + "static/media/S_logo.ef0bd8fd.png";